import { render, staticRenderFns } from "./PlanSettingsChannelDetail.vue?vue&type=template&id=20002130"
import script from "./PlanSettingsChannelDetail.vue?vue&type=script&lang=ts"
export * from "./PlanSettingsChannelDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports